import { pluralize } from './stringUtils';

const PLURAL = {
  YEARS: ['год', 'года', 'лет'],
  DAYS: ['день', 'дня', 'дней'],
  KIDS: ['ребёнок', 'ребёнка', 'детей'],
  ADULTS: ['взрослый', 'взрослых', 'взрослых'],
  NIGHTS: ['ночь', 'ночи', 'ночей'],
  TOURS: ['тур', 'тура', 'туров'],
  HOTELS: ['отель', 'отеля', 'отелей'],
  FLIGHTS: ['рейс', 'рейса', 'рейсов'],
  OPTIONS: ['вариант', 'варианта', 'вариантов'],
  REVIEWS: ['отзыв', 'отзыва', 'отзывов'],
  TOURISTS: ['турист', 'туриста', 'туристов'],
  TOURISTS_ACC: ['туриста', 'туристов', 'туристов'],
  HOURS_GEN: ['часе', 'часах', 'часах'],
  MINUTES_GEN: ['минуте', 'минутах', 'минутах'],
  LUGGAGE: ['место', 'места', 'мест'],
};
export const pluralizeYears = (value: number) => pluralize(value, PLURAL.YEARS);
export const pluralizeDays = (value: number) => pluralize(value, PLURAL.DAYS);
export const pluralizeKids = (value: number) => pluralize(value, PLURAL.KIDS);
export const pluralizeAdults = (value: number) => pluralize(value, PLURAL.ADULTS);
export const pluralizeNights = (value: number) => pluralize(value, PLURAL.NIGHTS);
export const pluralizeTours = (value: number) => pluralize(value, PLURAL.TOURS);
export const pluralizeHotels = (value: number) => pluralize(value, PLURAL.HOTELS);
export const pluralizeFlights = (value: number) => pluralize(value, PLURAL.FLIGHTS);
export const pluralizeOptions = (value: number) => pluralize(value, PLURAL.OPTIONS);
export const pluralizeReviews = (value: number) => pluralize(value, PLURAL.REVIEWS);
export const pluralizeTourists = (value: number) => pluralize(value, PLURAL.TOURISTS);
export const pluralizeTouristsAcc = (value: number) => pluralize(value, PLURAL.TOURISTS_ACC);
export const pluralizeHoursGen = (value: number) => pluralize(value, PLURAL.HOURS_GEN);
export const pluralizeMinutesGen = (value: number) => pluralize(value, PLURAL.MINUTES_GEN);
export const pluralizeLuggage = (value: number) => pluralize(value, PLURAL.LUGGAGE);
